import { deliveryCountryIds } from '@core/constants/Country';
import PersonaId from '@core/constants/Persona';
import AvailabilityOptionId from '@core/constants/AvailabilityOption';
import { ShippingAccessId, ShippingFloorId } from '@core/constants/ShippingDetail';
import {
    IFormFieldContactKey,
    IFormInputType,
    IFormFieldContact,
} from '../../../interfaces/Form';

const fieldsContact: IFormFieldContact = {
    [IFormFieldContactKey.Persona]: {
        value   : undefined,
        options : [
            PersonaId.InteriorDesigner,
            PersonaId.Professional,
            PersonaId.Reseller,
            PersonaId.Particular,
        ],
        required: true,
    },
    [IFormFieldContactKey.FirstName]: {
        value    : undefined,
        type     : IFormInputType.Text,
        required : true,
    },
    [IFormFieldContactKey.LastName]: {
        value    : undefined,
        type     : IFormInputType.Text,
        required : true,
    },
    [IFormFieldContactKey.Email]: {
        value    : undefined,
        type     : IFormInputType.Email,
        required : true,
    },
    [IFormFieldContactKey.Phone]: {
        value    : undefined,
        type     : IFormInputType.Tel,
        required : true,
    },
    [IFormFieldContactKey.Availability]: {
        value   : undefined,
        options : [
            AvailabilityOptionId.NoPreference,
            AvailabilityOptionId.ByPhoneNineToTwelve,
            AvailabilityOptionId.ByPhoneTwelveToTwo,
            AvailabilityOptionId.ByPhoneTwoToSix,
            AvailabilityOptionId.ByPhoneAfterSix,
        ],
        required: true,
    },
    [IFormFieldContactKey.ShippingAddressZip]: {
        value    : undefined,
        type     : IFormInputType.Number,
        required : true,
    },
    [IFormFieldContactKey.ShippingAddressCountry]: {
        value    : undefined,
        options  : deliveryCountryIds,
        required : true,
    },
    [IFormFieldContactKey.ShippingAddressFloor]: {
        value   : undefined,
        options : [
            ShippingFloorId.Rdc,
            ShippingFloorId.First,
            ShippingFloorId.Second,
            ShippingFloorId.Third,
            ShippingFloorId.Fourth,
            ShippingFloorId.Fifth,
            ShippingFloorId.FifthPlus,
        ],
        required: true,
    },
    [IFormFieldContactKey.ShippingAddressAccess]: {
        value   : undefined,
        options : [
            ShippingAccessId.Easy,
            ShippingAccessId.Hard,
        ],
        required: true,
    },
};

export default fieldsContact;
